 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/coverpage'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import HALF_TITLE from '@/components/half_title'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import DAY_01 from '@/components/day_01'
 import DAY_02 from '@/components/day_02'
 import DAY_03 from '@/components/day_03'
 import DAY_04 from '@/components/day_04'
 import DAY_05 from '@/components/day_05'
 import DAY_06 from '@/components/day_06'
 import DAY_07 from '@/components/day_07'
 import DFDFTURN from '@/components/DF/DF-turn'
 import DFDFCOVER from '@/components/DF/DF-cover'
 import DFDF from '@/components/DF/DF'
 import DFDF1 from '@/components/DF/DF-1'
 import LOVE_2 from '@/components/love_2'
 import ACKNOWLEDGEMENT from '@/components/acknowledgement'
 import GLOSSARY from '@/components/glossary'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/coverpage",
 			"name" : "coverpage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/day_01",
 			"name" : "day_01",
 			"component" : DAY_01
 		},
 		{
 			"path" : "/day_02",
 			"name" : "day_02",
 			"component" : DAY_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js